<template>
  <div class="main contactMain">
    <div class="top">
      <span class="title">咨询联系</span>
    </div>

    <div class="container">
      <div class="heading">
        <i class="el-icon-message"></i>
        <span class="caption">咨询联系</span>
      </div>

      <!--百度地图容器-->
      <div style="display: flex;">
        <div class="mapContainer" id="map"></div>
        <div class="address">
          <p>联系人：周翀</p>
          <p>联系电话1：64878019</p>
          <p>联系电话2：15902160342</p>
          <p>地址：宛平南路75号1号楼902室</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 标注点数组
var markers = [
  {
    content: '宛平南路75号1号楼902室',
    title: '绿色建筑协会',
    imageOffset: { width: 0, height: 3 },
    position: { lat: 31.201893, lng: 121.452288 }
  }
]

export default {
  data () {
    return {}
  },
  mounted () {
    this.initMap()
  },
  methods: {
    // 创建和初始化地图函数：
    initMap () {
      this.createMap() // 创建地图
      this.setMapEvent() // 设置地图事件
      this.addMapControl() // 向地图添加控件
      this.addMapOverlay() // 向地图添加覆盖物
    },
    createMap () {
      var map = new window.BMap.Map('map')
      map.centerAndZoom(new window.BMap.Point(121.454862, 31.204113), 16)
      window.map = map
    },
    setMapEvent () {
      window.map.enableScrollWheelZoom()
      window.map.enableKeyboard()
      window.map.enableDragging()
      window.map.enableDoubleClickZoom()
    },
    addClickHandler (target, window) {
      target.addEventListener('click', function () {
        target.openInfoWindow(window)
      })
    },
    addMapOverlay () {
      for (var index = 0; index < markers.length; index++) {
        var point = new window.BMap.Point(
          markers[index].position.lng,
          markers[index].position.lat
        )
        var marker = new window.BMap.Marker(point, {
          icon: new window.BMap.Icon(
            'http://api.map.baidu.com/lbsapi/createmap/images/icon.png',
            new window.BMap.Size(20, 25),
            {
              imageOffset: new window.BMap.Size(
                markers[index].imageOffset.width,
                markers[index].imageOffset.height
              )
            }
          )
        })
        var label = new window.BMap.Label(markers[index].title, {
          offset: new window.BMap.Size(25, 5)
        })
        var opts = {
          width: 200,
          title: markers[index].title,
          enableMessage: false
        }
        var infoWindow = new window.BMap.InfoWindow(
          markers[index].content,
          opts
        )
        marker.setLabel(label)
        this.addClickHandler(marker, infoWindow)
        window.map.addOverlay(marker)
      }
      var labels = []
      for (var _index = 0; _index < labels.length; _index++) {
        var opt = {
          position: new window.BMap.Point(
            labels[_index].position.lng,
            labels[_index].position.lat
          )
        }
        var _label = new window.BMap.Label(labels[_index].content, opt)
        window.map.addOverlay(_label)
      }
      var plOpts = []
      var plPath = []
      for (var _index_ = 0; _index_ < plOpts.length; _index_++) {
        var polyline = new window.BMap.Polyline(
          plPath[_index_],
          plOpts[_index_]
        )
        window.map.addOverlay(polyline)
      }
    },
    // 向地图添加控件
    addMapControl () {
      var scaleControl = new window.BMap.ScaleControl({
        anchor: window.BMAP_ANCHOR_BOTTOM_LEFT
      })
      scaleControl.setUnit(window.BMAP_UNIT_IMPERIAL)
      window.map.addControl(scaleControl)
      var navControl = new window.BMap.NavigationControl({
        anchor: window.BMAP_ANCHOR_TOP_LEFT,
        type: window.BMAP_NAVIGATION_CONTROL_LARGE
      })
      window.map.addControl(navControl)
      var overviewControl = new window.BMap.OverviewMapControl({
        anchor: window.BMAP_ANCHOR_BOTTOM_RIGHT,
        isOpen: true
      })
      window.map.addControl(overviewControl)
    }
  }
}
</script>

<style lang="scss">
.contactMain {
  .container {
    padding-left: 70px;
    .heading {
      margin: 10px 0;
      i {
        vertical-align: text-bottom;
        font-size: 24px;
        color: #00aff0;
      }
      .caption {
        margin-left: 6px;
        font-size: 20px;
        color: #00b0f0;
        font-weight: bold;
      }
    }
    .mapContainer {
      width: 500px;
      height: 450px;
      border: #ccc solid 1px;
      margin-left: 50px;
    }
    .address {
      margin-top: 50px;
      color: #535050;
      font-weight: 400;
      margin-left: 60px;
      line-height: 30px;
    }
  }
  .BMapLabel {
    font-size: 18px !important;
    border-color: #000 !important;
  }
  .BMap_bubble_title {
    color: #f00;
  }
  .BMap_bubble_content {
    font-size: 14px;
  }
}
</style>
